import React from "react";
import CardContainer from './CardContainer';

const CardElement = (props) => {
  const { element, elementStyle } = props;
  const { id } = element;
  return (
    <CardContainer
      elementId={id}
      customClasses={['webiny-pb-base-page-element-style webiny-pb-layout-collapse-page formBuilder-show-collapse']}
      elementStyle={elementStyle}
    />
  );
};

export default React.memo(CardElement);
